










import { Component, Prop, Vue } from 'vue-property-decorator';
import { WARNING_TEXT } from './consts';

@Component
export default class Statement extends Vue {
  @Prop({ type: String, default: '' })
  readonly statement!: string;

  warningText: string = WARNING_TEXT;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/statement/Statement.vue